import { Box } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { FC, useMemo } from 'react';

import { getTracksGroups } from '@/components/ui/features/schedule/ScheduleCalendar/ScheduleCalendar.utils';
import { ListGroup } from '@/components/ui/features/schedule/ScheduleListView/components/ListGroup';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { queryThinEventSessionsForDay } from '@/queries/thin-event-sessions';

interface IUrlQueryStringParams {
  day?: string;
  view?: string;
  eventId?: string;
  trackId?: string;
  timeZone?: string;
}

interface IScheduleList {
  startAt: string;
  endAt: string;
}

export const ScheduleListEmbed: FC<IScheduleList> = ({ startAt, endAt }) => {
  const { eventId, trackId } = useQueryParams<IUrlQueryStringParams>({
    view: StringParam,
    eventId: StringParam,
    trackId: StringParam,
    timeZone: StringParam,
  });

  const { data: eventSessions, mutate: mutateSession } = useResources(
    queryThinEventSessionsForDay(eventId, trackId, startAt, endAt)
  );

  const tracksGroups = useMemo(() => getTracksGroups(eventSessions), [eventSessions]);

  return (
    <Box>
      {Object.entries(tracksGroups).map(([date, session]) => (
        <ListGroup mutateSession={mutateSession} newTab={true} key={date} date={date} sessions={session} />
      ))}
    </Box>
  );
};
